import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "passportFilled"
const PassportFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.924 10.313C12.86 11.768 12.543 12.634 12.262 13.127 12.169 13.29 12.078 13.411 12 13.504 11.922 13.41 11.83 13.289 11.739 13.127 11.457 12.634 11.14 11.768 11.076 10.312zM9.95 10.313C10.01 11.759 10.296 12.759 10.634 13.442 9.302 12.952 8.31 11.76 8.104 10.314zM15.897 10.313C15.69 11.759 14.697 12.95 13.365 13.442 13.703 12.76 13.99 11.76 14.05 10.314zM10.634 6.056C10.296 6.74 10.01 7.74 9.95 9.188H8.104C8.31 7.74 9.302 6.547 10.634 6.056M12 5.996C12.078 6.088 12.17 6.21 12.261 6.373 12.544 6.865 12.86 7.732 12.925 9.188H11.076C11.14 7.732 11.457 6.865 11.738 6.373 11.832 6.21 11.923 6.088 12 5.996M13.365 6.056C14.698 6.548 15.69 7.74 15.896 9.188H14.05C13.99 7.74 13.703 6.74 13.365 6.056" />
          <path
            fillRule="evenodd"
            d="M18.75 1.5C19.578 1.5 20.25 2.172 20.25 3V21C20.25 21.828 19.578 22.5 18.75 22.5H5.25C4.422 22.5 3.75 21.828 3.75 21V3C3.75 2.172 4.422 1.5 5.25 1.5zM8.25 17.813C7.94 17.813 7.688 18.064 7.688 18.375 7.688 18.685 7.939 18.938 8.25 18.938H15.75C16.06 18.938 16.313 18.686 16.313 18.375S16.06 17.813 15.75 17.813zM12 4.688C9.204 4.688 6.938 6.954 6.938 9.75S9.204 14.813 12 14.813 17.063 12.546 17.063 9.75 14.796 4.688 12 4.688"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PassportFilledIcon
